import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { firstAllowedPath } from "../config/modules";

// Renders children only if the signed-in user has the module (admins always do).
// The backend enforces the same rule on every API call; this just keeps the UI tidy.
export function ModuleGuard({ module, children }) {
  const { user } = useAuth();
  const ok = user.role === "admin" || user.modules.includes(module);
  return ok ? children : <Navigate to={firstAllowedPath(user)} replace />;
}

export function AdminGuard({ children }) {
  const { user } = useAuth();
  return user.role === "admin" ? children : <Navigate to={firstAllowedPath(user)} replace />;
}
